module.exports = __webpack_public_path__ + "img/ridley-min.b227f206.png";